export default "__VITE_ASSET__6ba54ec2__"